/**
 * notification (알림) orval 래퍼
 */
import { customInstance } from "../custom-instance";
// ── API 함수 ──
export async function getNotificationLogs(params) {
    return customInstance({
        url: "/notification/log",
        method: "GET",
        params,
    });
}
export async function getFailedNotificationLogs() {
    return customInstance({
        url: "/notification/log/failed",
        method: "GET",
    });
}
export async function postResendNotification(id) {
    return customInstance({
        url: `/notification/log/${id}/resend`,
        method: "POST",
    });
}
export async function postResendAllFailed() {
    return customInstance({
        url: "/notification/log/resend-all-failed",
        method: "POST",
    });
}
// ── SDK 객체 ──
export const notificationApi = {
    getNotificationLogs,
    getFailedNotificationLogs,
    postResendNotification,
    postResendAllFailed,
};
